export const IconData = [
    {
        icon:
            'React-icon.webp'
    },
    {
        icon:
            'blender.png'
    },
    {
        icon:
            'css.webp'
    },
    {
        icon:
            'html.png'
    },
    {
        icon:
            'unity3d.webp'
    },
    {
        icon:
            'blazor.webp'
    },
    {
        icon:
            'c.png'
    },
    {
        icon:
            'unreal_engine.png'
    }
];